/**
 * Mutations for updating the state via actions.
 * Names should reference from mutation types
 */

import * as types from './mutation-types';

export const mutations = {
  [types.SET_FEED](state, payload) {
    state.feed = payload;
  },

  [types.SET_LIMIT](state, limit) {
    state.props.limit = limit;
  },

  [types.SET_FILTER](state, limit) {
    state.props.contentTypes = limit;
  },
  [types.SET_MAX_QUERY_SIZE](state, limit) {
		state.largestQuerySize = limit
  },
  [types.SET_STATUS](state, status) {
		state.status = status
	}
};
